module.exports = __webpack_public_path__ + "static/img/huaweidcb1.1dc53ccc.png";